// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayerTime__container-a7559b {
  color: var(--addition-50);
  font: var(--font-body-4);
}

.VideoPlayerTime__container-a7559b.VideoPlayerTime__mini-b5f0b4 {
  font: var(--font-caption-2);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayerTime/VideoPlayerTime.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,wBAAA;AACF;;AAEA;EACE,2BAAA;AACF","sourcesContent":[".container {\n  color: var(--addition-50);\n  font: var(--font-body-4);\n}\n\n.container.mini {\n  font: var(--font-caption-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VideoPlayerTime__container-a7559b`,
	"mini": `VideoPlayerTime__mini-b5f0b4`
};
module.exports = ___CSS_LOADER_EXPORT___;
